var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabItem = void 0;
var TabItem_1 = __importDefault(require("./TabItem"));
exports.TabItem = TabItem_1.default;
exports.default = TabItem_1.default;
//# sourceMappingURL=index.js.map